import { ReactNode } from 'react';
import { Link } from 'react-router-dom';
import { Heart } from 'lucide-react';
import { usePartnerBranding, getPartnerColorStyles } from '@/contexts/PartnerBrandingContext';

interface PartnerBrandedWrapperProps {
  children: ReactNode;
  showHeader?: boolean;
}

export function PartnerBrandedWrapper({ children, showHeader = true }: PartnerBrandedWrapperProps) {
  const { partner, isPartnerContext } = usePartnerBranding();

  if (!isPartnerContext || !partner) {
    return <>{children}</>;
  }

  const colorStyles = getPartnerColorStyles(partner.primary_color);

  return (
    <div style={colorStyles}>
      {showHeader && (
        <div className="fixed top-0 left-0 right-0 z-50 bg-card border-b border-border">
          <div className="container mx-auto px-4 py-3 flex items-center justify-between">
            <div className="flex items-center gap-3">
              {partner.logo_url ? (
                <img 
                  src={partner.logo_url} 
                  alt={partner.partner_name}
                  className="h-8 w-auto object-contain"
                />
              ) : (
                <div className="h-8 w-8 rounded-lg bg-primary flex items-center justify-center">
                  <span className="text-primary-foreground font-bold">
                    {partner.partner_name.charAt(0)}
                  </span>
                </div>
              )}
              <span className="font-medium text-foreground">{partner.partner_name}</span>
            </div>
            
            <div className="flex items-center gap-2 text-xs text-muted-foreground">
              <span>Powered by</span>
              <Link to="/" className="inline-flex items-center gap-1 text-foreground hover:text-accent transition-colors">
                <Heart className="w-3 h-3 text-accent fill-accent" />
                <span className="font-medium">Living Tribute</span>
              </Link>
            </div>
          </div>
        </div>
      )}
      
      <div className={showHeader ? 'pt-14' : ''}>
        {children}
      </div>
    </div>
  );
}

// Component to show partner context message on auth pages
export function PartnerContextBanner() {
  const { partner, isPartnerContext } = usePartnerBranding();

  if (!isPartnerContext || !partner) {
    return null;
  }

  return (
    <div className="text-center text-sm text-muted-foreground mb-4 p-3 bg-muted/50 rounded-lg">
      <span>You're creating a tribute through </span>
      <span className="font-medium text-foreground">{partner.partner_name}</span>
    </div>
  );
}
